import { getWorkflowWithRedirectSafe } from "@/shared/api/workflows";
import { WorkflowBreadcrumbs } from "./workflow-breadcrumbs";
import WorkflowDetailHeader from "./workflow-detail-header";
export default async function Layout(props: {
  children: React.ReactNode;
  params: Promise<{
    workflow_id: string;
  }>;
}) {
  const params = await props.params;
  const {
    children
  } = props;
  const workflow = await getWorkflowWithRedirectSafe(params.workflow_id);
  return <div className="flex flex-col h-full gap-4" data-sentry-component="Layout" data-sentry-source-file="layout.tsx">
      <WorkflowBreadcrumbs workflowId={params.workflow_id} data-sentry-element="WorkflowBreadcrumbs" data-sentry-source-file="layout.tsx" />
      <WorkflowDetailHeader workflowId={params.workflow_id} initialData={workflow} data-sentry-element="WorkflowDetailHeader" data-sentry-source-file="layout.tsx" />
      <div className="flex-1 flex flex-col">{children}</div>
    </div>;
}